import { useQuery } from "react-query";

import { makeSimpleGetRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { AssetAdministration, SellerAssetAdministration } from "./types";

export const useManyAssetAdministrations = () => {
  return useQuery("manyAssetAdministrations", () =>
    makeSimpleGetRequest<AssetAdministration[]>(
      `${ORDERBOOK_URL}/asset-administrations/?include[]=asset.resale_info.*`,
    ),
  );
};

export const useSellerAssetAdministrations = () => {
  return useQuery("sellerAssetAdministrations", () =>
    makeSimpleGetRequest<SellerAssetAdministration[]>(
      `${ORDERBOOK_URL}/seller-asset-administrations/?include[]=asset.resale_info.*`,
    ),
  );
};
